import { Document } from "@react-pdf/renderer";
import OrderPagePDF from "./OrderPagePDF";
import { OrderDataForPDF } from "@/app/interfaces/response/OrderPdfDataResponse";

const OrdersPDF = ({ orders }: { orders: OrderDataForPDF[] }) => {
  return (
    <Document>
      {orders.map((order) => (
        <OrderPagePDF key={order.id} order={order} />
      ))}
    </Document>
  );
};

export default OrdersPDF;
